<template>
  <div style="margin: 0px 30px" class="report-15" dir="rtl">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

    <!-- <h3 style="margin-bottom: 15px" class="text-center">{{ fullName }}</h3>
        <h3 style="margin-top: 0px" class="text-center">
            {{ shortName }}
        </h3> -->
    <h3
      style="font-weight: bold; padding-bottom: 40px; padding-top: 20px"
      class="text-center"
    >
      كشف برصيد الإجازة السنوية
    </h3>

    <div class="md-layout-item md-size-100 mt-25">
      <h4 style="font-weight: bold" class="text-center">
        تقرير بأرصدة الإجازات حتى تاريخ
        <span style="margin: 5px"> {{ monthDate }} </span> للموظفين أصحاب
        الأرصدة الأكثر من <span style="margin: 5px"> {{ Days }} </span> يوما
      </h4>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header
            style="margin-bottom: 30px"
            class="md-card-header-text md-card-header-green"
          >
            <div class="card-text">
              <h4 class="title">كشف برصيد الإجازة السنوية</h4>
            </div>
          </md-card-header>

          <div style="margin-top: 10px; margin-bottom: 35px" class="marginTop">
            <md-card-content>
              <md-table class="paginated-table table-striped table-hover mt-25">
                <md-table-row>
                  <md-table-cell>ر.م</md-table-cell>

                  <md-table-cell>اسم الموظف</md-table-cell>

                  <md-table-cell>الرقم الوظيفي</md-table-cell>

                  <md-table-cell>الادارة</md-table-cell>

                  <md-table-cell>رصيد الإجازات</md-table-cell>
                </md-table-row>
                <md-table-row v-for="(item, i) in allData" :key="i">
                  <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.employeeName
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.jobNumber
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.departmentName
                  }}</md-table-cell>

                  <md-table-cell md-label="الصنف">{{
                    item.balanceDays
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div
            style="margin-bottom: 30px; margin-right: 20px"
            class="md-layout"
          >
            <div class="md-layout-item md-size-40 ml-15">
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label>عدد الموظفين أصحاب الأرصدة فوق 180 يوم</label>
                <md-input disabled v-model="countEmployee"></md-input>
              </md-field>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
  
<script>
import env from "../../../env";

export default {
  props: [
    "allData",
    "fullName",
    "shortName",
    "Days",
    "monthDate",
    "countEmployee",
  ],
  data() {
    return {
      m: env.mTop(),
    };
  },
};
</script>
  
<style lang="scss" scoped>
@import "../../assets/css/vacations_balance";
</style>
  